import HTTP_METHODS from "src/general/constants/http/httpMethods";
import {
	UserGetRequest as Req,
	UserGetResponse as Res,
} from "src/business.InterfaceLayer/store/entities/user.entity/redux/api/types/GET";
import { createBaseQueryDefinition } from "src/business.InterfaceLayer/store/services/utils.service/ResponseTransforms";
import MAIN_PATHS from "src/business.InterfaceLayer/store/mainPaths";
import { ApiQueryBuilder } from "src/business.InterfaceLayer/store/types/ApiQueryBuilder.type";
import { AuthFromDtoGet as Dto } from "src/business.InterfaceLayer/store/entities/user.entity/services/dto/from.dto";
import { Nullable } from "../../../../../types/Nullable.type";
import USER_PATHS from "../../paths";
import { USER_FIELDS } from "../../fields";
import COMMON_FIELDS from "../../../../../../../general/constants/commonFields";
import { ORDER } from "../../type";

const getRequestBaseDefinition = createBaseQueryDefinition(
	HTTP_METHODS.GET,
	MAIN_PATHS.CORE
);

const userApiGetQueries = (build: ApiQueryBuilder) => ({
	getUsers: build.query<Nullable<Res.UsersGet>, Req.UsersGet>({
		query: (params) => ({
			...getRequestBaseDefinition({
				path: USER_PATHS.USERS,
				params: {
					...params,
					[COMMON_FIELDS.SORT_BY]: params?.[COMMON_FIELDS.SORT_BY]
						?.map((e) => {
							return `${e?.[COMMON_FIELDS.ID]}${
								e?.[COMMON_FIELDS.TYPE] === ORDER.ASC ? "+" : "-"
							}`;
						})
						?.join(),
				},
			}),
		}),
		transformResponse: Dto.userGetUsers,
		providesTags: [`${MAIN_PATHS.USER}TAG`],
		keepUnusedDataFor: 0,
	}),
	getProfile: build.query<Nullable<Res.ProfileGet>, Req.ProfileGet>({
		query: (params) => ({
			...getRequestBaseDefinition({
				path: USER_PATHS.PROFILE_USER,
				params: { avatar: true, desktop: true, ...params },
			}),
		}),
		transformResponse: Dto.userGetProfile,
		providesTags: [`${MAIN_PATHS.USER}TAG_PROFILE`],
	}),
	getUserID: build.query<Nullable<Res.UserIDGet>, Req.UserIDGet>({
		query: (body) => ({
			...getRequestBaseDefinition({
				path: `${USER_PATHS.USERS}/${body?.[USER_FIELDS.ID]}`,
			}),
		}),
		transformResponse: Dto.userIDGetUsers,
		providesTags: [`${MAIN_PATHS.USER}TAG`, `${MAIN_PATHS.USER}TAG_ID`],
		keepUnusedDataFor: 0,
	}),
	getUsersCount: build.query<Nullable<Res.UsersCountGet>, Req.UsersCountGet>({
		query: (params) => ({
			...getRequestBaseDefinition({ path: USER_PATHS.USER_COUNT, params }),
		}),
		transformResponse: Dto.userCountGetUsers,
		providesTags: [`${MAIN_PATHS.USER}TAG`, `${MAIN_PATHS.USER}TAG_COUNT`],
	}),
	getUsersManagers: build.query<
		Nullable<Res.UsersManagersGet>,
		Req.UsersManagersGet
	>({
		query: (params) => ({
			...getRequestBaseDefinition({ path: USER_PATHS.USER_MANAGERS, params }),
		}),
		transformResponse: Dto.userManagersGetUsers,
		providesTags: [`${MAIN_PATHS.USER}TAG`],
	}),
	getUsersRequestPasswordCount: build.query<
		Nullable<Res.UsersRequestPasswordCountGet>,
		Req.UsersRequestPasswordCountGet
	>({
		query: (params) => ({
			...getRequestBaseDefinition({
				path: USER_PATHS.USER_REQUESTS_PASSWORD_COUNT,
				params,
			}),
		}),
		transformResponse: Dto.userCountGetUsersRequestPassword,
		providesTags: [`${MAIN_PATHS.USER}TAG_COUNT_REQUESTS_PASSWORD`],
	}),
	getUsersRequestPassword: build.query<
		Nullable<Res.UsersRequestPasswordGet>,
		Req.UsersRequestPasswordGet
	>({
		query: (params) => ({
			...getRequestBaseDefinition({
				path: USER_PATHS.USER_REQUESTS_PASSWORD,
				params: {
					...params,
					[COMMON_FIELDS.SORT_BY]: params?.[COMMON_FIELDS.SORT_BY]
						?.map((e) => {
							return `${e?.[COMMON_FIELDS.ID]}${
								e?.[COMMON_FIELDS.TYPE] === ORDER.ASC ? "+" : "-"
							}`;
						})
						?.join(),
				},
			}),
		}),
		transformResponse: Dto.UsersRequestPassword,
		providesTags: [`${MAIN_PATHS.USER}TAG_COUNT_REQUESTS_PASSWORD`],
		keepUnusedDataFor: 0,
	}),
	getUserRequestPasswordID: build.query<
		Nullable<Res.UserRequestPasswordGetID>,
		Req.UserRequestPasswordGetID
	>({
		query: (body) => ({
			...getRequestBaseDefinition({
				path: `${USER_PATHS.USER_REQUESTS_PASSWORD}/${body?.[USER_FIELDS.ID]}`,
			}),
		}),
		transformResponse: Dto.UserRequestPasswordID,
	}),
});

export default userApiGetQueries;
